<template>
  <Card :bordered="false" class="no-head-card views-count-card">
    <div slot="title" class="card-title">
      <Icon v-if='hIcon' :type="hIcon" size="22" color="#ffffff"/>
      <p>{{ htitle }}</p>
    </div>
    <slot name="content"></slot>
  </Card>
</template>

<script>
export default {
  props: {
    hIcon: {
      type: String,
      default: null
    },
    htitle: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.views-count-card {
  .card-title {
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-icon {
      background: $primary;
      padding: 8px;
      border-radius: 50%;
      margin-right:10px;
    }
  }
}
</style>
